import React from "react";
import { observer } from "mobx-react";
import GreetingBotPage from "~/modules/UiMeet3d/app/GreetingBotPage";
import "../styles/PanelGreetingBot.less";
// Moving the styles of the LayoutWrapper here to avoid getting the wrong variables
import "../styles/TourLayout.less";

const PanelGreetingBotPage = observer(props => <GreetingBotPage {...props} />);

export default PanelGreetingBotPage;
